import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
export const DEFAULT_FORM_CONFIG = { canWrite: true };
const FormConfigContext = createContext(DEFAULT_FORM_CONFIG);
export function FormConfigProvider({ canWrite, children, }) {
    const value = useMemo(() => ({ canWrite: canWrite ?? DEFAULT_FORM_CONFIG.canWrite }), [canWrite]);
    return (_jsx(FormConfigContext.Provider, { value: value, children: children }));
}
export function useFormConfig() {
    return useContext(FormConfigContext);
}
//# sourceMappingURL=form-config.js.map